export const BRANDLOGOFILENAME = 'admin-logo-affiliate.svg';